import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgenciesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgenciesQuery = { __typename?: 'Query', Agencies: Array<{ __typename?: 'Agency', id: any, name?: string | null, latitude: number, longitude: number }> };


export const AgenciesDocument = gql`
    query Agencies {
  Agencies {
    id
    name
    latitude
    longitude
  }
}
    `;

/**
 * __useAgenciesQuery__
 *
 * To run a query within a React component, call `useAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgenciesQuery(baseOptions?: Apollo.QueryHookOptions<AgenciesQuery, AgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgenciesQuery, AgenciesQueryVariables>(AgenciesDocument, options);
      }
export function useAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgenciesQuery, AgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgenciesQuery, AgenciesQueryVariables>(AgenciesDocument, options);
        }
export type AgenciesQueryHookResult = ReturnType<typeof useAgenciesQuery>;
export type AgenciesLazyQueryHookResult = ReturnType<typeof useAgenciesLazyQuery>;
export type AgenciesQueryResult = Apollo.QueryResult<AgenciesQuery, AgenciesQueryVariables>;